import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { NewActivityComponent } from '../partials/new-activity/new-activity.component';
import { AuthenticationService } from '../../services/authentication.service';
import { DBService } from '../../services/db.service';
import { Company } from '../../model/company';
import { User } from '../../model/user';
import { Activity, ActivityStatus } from '../../model/activity';
import { ConfirmDeleteComponent } from '../partials/confirm-delete/confirm-delete.component';
import { NewBiddingComponent } from '../partials/new-bidding/new-bidding.component';
import { Bidding, BiddingStatus, BiddingUpdateAction } from '../../model/bidding';
import { Employee } from '../../model/employee';
import { InputDataComponent } from '../partials/input-data/input-data.component';
import { RejectBiddingComponent } from '../partials/reject-bidding/reject-bidding.component';
import { HttpClient } from '@angular/common/http';

declare var Materialize: any;


@Component({
  selector: 'app-biddings',
  templateUrl: './biddings.component.html',
  styleUrls: ['./biddings.component.css'],
  providers: [DBService, AuthenticationService]
})
export class BiddingsComponent implements OnInit {

  loading: boolean;
  showResult: boolean;

  companies: Company[];

  users: User[];

  allBiddings: Bidding[];
  biddings: Bidding[];

  searchText: string;
  statusFilter: number;
  companyFilter: string;

  now: number = Date.now();

  employee: Employee;
  isAdminUser: boolean;
  
  userCompanyUID: string;
  
  AlteraLicitacao = 'https://us-central1-i-ganhei.cloudfunctions.net/AlteraLicitacao';

  constructor(public dialog: MatDialog, private dbService: DBService, private authService: AuthenticationService, private http: HttpClient) {
    this.loading = true;
    this.statusFilter = 1;
    this.companyFilter = '0';
    this.searchText = '';

    if (!this.authService.isAdmin()) {
      this.userCompanyUID = this.authService.getUserCompany();
    }

    this.loadEmployee();
    this.loadCompanies();
  }

  private loadEmployee() {
    this.isAdminUser = this.authService.isAdmin();

    const user = this.authService.getUser();

    this.dbService.getObject<Employee>(`employees/${user.uid}`)
      .then(employee => {
        this.employee = employee;
        this.isAdminUser = this.employee && this.employee.companyUID === 'I-Ganhei';

        this.loadUsers();
    });
  }

   private loadCompanies() {
    this.dbService.listWithUIDs<Company>('companies')
      .then(companies => this.companies = companies);
  }

  private loadUsers() {
    this.dbService.listWithUIDs<User>('users')
      .then(users => {
        this.users = users;

        this.loadBiddings();
      });
  }

  private loadBiddings() {
    this.showResult = false;
    this.dbService.listWithUIDs<Bidding>('biddings')
      .then(biddings => {
        this.allBiddings = biddings.sort((a1, a2) => a2.creationDate - a1.creationDate);

        if (!this.isAdminUser && this.employee) {
          this.companyFilter = this.employee.companyUID;
        }
        this.updateBiddings();
        this.filterData();
      });
  }

  onSearchChange(searchValue: string ) {
    this.searchText = searchValue.toLowerCase();
    this.filterData();
  }

  filterData() {
    this.showResult = true;
    let displayBiddings = this.allBiddings;

    if (this.statusFilter != 0) {
      displayBiddings = displayBiddings.filter(a => a.status == this.statusFilter);
    }

    if (this.companyFilter != '0') {
      displayBiddings = displayBiddings.filter(a => a.companyUID == this.companyFilter);
    }

    if (this.searchText.trim().length > 1) {
      displayBiddings = displayBiddings
      .filter(item => item.purchasingOrgan.toLowerCase().includes(this.searchText) ||
                      item.biddingDateString.toLowerCase().includes(this.searchText) ||
                      item.product.toLowerCase().includes(this.searchText) ||
                      item['userText'].toLowerCase().includes(this.searchText) ||
                      item['companyText'].toLowerCase().includes(this.searchText) ||
                      item['statusText'].toLowerCase().includes(this.searchText));
    }

    this.biddings = displayBiddings;

    this.loading = false;
  }

  private updateBiddings() {
    const now = Date.now();

    this.allBiddings.forEach(bidding => {
      if (bidding.status === BiddingStatus.NEW) {
        bidding['statusText'] = 'Aguardando cliente';
      } else if (bidding.status === BiddingStatus.ACCEPTED) {
        bidding['statusText'] = 'Aceita pelo cliente';
      } else if (bidding.status === BiddingStatus.REFUSED) {
        bidding['statusText'] = 'Recusada pelo cliente';
      } else if (bidding.status === BiddingStatus.EARNED) {
        bidding['statusText'] = 'Vencida';
      } else if (bidding.status === BiddingStatus.LOST) {
        bidding['statusText'] = 'Perdida';
      } else if (bidding.status === BiddingStatus.FAIL) {
        bidding['statusText'] = 'Fracassada';
      }

      bidding['companyText'] = '';

      const filteredCompanies = this.companies.filter(c => c.uid === bidding.companyUID);
      if (filteredCompanies.length > 0) {
        bidding['companyText'] = filteredCompanies[0].name;
      } else {
        this.dbService.remove('biddings', bidding.uid);
      }
      
      bidding['userText'] = this.users.filter(u => u.uid === bidding.sentUserUID);

      if(bidding['userText'].length > 0) 
        bidding['userText'] = bidding['userText'][0].name;
      else 
        bidding['userText'] = "Usuário não identificado ou excluído.";
    });

    this.allBiddings = this.allBiddings.filter(b => b['companyText'] != '');

    this.loading = false;
  }

  ngOnInit() {
  }

  goToNew() {
    const dialogRef = this.dialog.open(NewBiddingComponent, {
      height: 'auto',
      width: '875px',
      data: {  }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) { this.confirmNew(result); }
    });
  }

  goToEdit(bidding: Bidding) {
    const dialogRef = this.dialog.open(NewBiddingComponent, {
      height: 'auto',
      width: '875px',
      data: { uid: bidding.uid  }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) { this.confirmNew(result); }
    });
  }

  confirmNew(result: any) {
    this.resetData();
  }

  private resetData() {
    this.loading = true;
    this.biddings = [];
    this.loadBiddings();
  }

  openDeleteModal(activity: Activity) {
    const dialogRef = this.dialog.open(ConfirmDeleteComponent, {
      height: 'auto',
      width: '600px',
      data: { name: 'Licitação' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) { this.confirmDelete(activity.uid); }
    });
  }

  private confirmDelete(uid: string) {
    this.loading = true;
    this.dbService.remove('/biddings', uid)
      .then(() => {
        Materialize.toast('Licitação removida com sucesso', 2000);
        this.resetData();
      })
      .catch(error => console.log(error));
  }

  openAcceptModal(bidding: Bidding) {
    const dialogRef = this.dialog.open(InputDataComponent, {
      height: 'auto',
      width: '900px',
      data: {
        isAcceptLicitation: true,
        title: 'Aceitar participar da licitação',
        placeHolder: 'Valor mínimo para participação (R$)',
        isCurrency: true
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) { this.confirmAccept(result, bidding.uid); }
    });
  }

  confirmAccept(result: any, uid: string) {
    const updatingObj = {
      status: BiddingStatus.ACCEPTED,
      companyMaximumPrice: result.inputData,
      updatingDate: Date.now(),
      updatingAction: BiddingUpdateAction.ACCEPTED
    };

    if (result.list && result.list.length > 0) {
      updatingObj['acceptList'] = result.list;
    }

    if (result.biddable) {
      updatingObj['biddable'] = result.biddable;
    }

    this.dbService.update(`biddings/${uid}`, updatingObj)
      .then(() => {
        Materialize.toast('Licitação aceita com sucesso', 2000);
        this.resetData();
        this.sendAlteraEmail(uid, "Aceita");
      });
  }

  openRefuseModal(bidding: Bidding) {
    const dialogRef = this.dialog.open(InputDataComponent, {
      height: 'auto',
      width: '600px',
      data: { title: 'Recusar participar da licitação', placeHolder: 'Motivo da recusa' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) { this.confirmRefuse(result, bidding.uid); }
    });
  }

  confirmRefuse(result: any, uid: string) {
    this.dbService.update(`biddings/${uid}`,
    {
      status: BiddingStatus.REFUSED,
      refusedReason: result,
      updatingDate: Date.now(),
      updatingAction: BiddingUpdateAction.REFUSED
    })
      .then(() => {
        Materialize.toast('Licitação recusada com sucesso', 2000);
        this.resetData();
        this.sendAlteraEmail(uid, "Recusada");
      });
  }

  sendAlteraEmail(uid, status) {

    var biddingSelected = this.biddings.filter(b => b.uid === uid)[0].edital;

    const dataNotify = {
      editalAlteraLicitacao: biddingSelected,
      statusBiddingAlteraLicitacao: status
    }

    this.http.post(this.AlteraLicitacao, dataNotify).subscribe();

  }

  openWinModal(bidding: Bidding) {
    const dialogRef = this.dialog.open(InputDataComponent, {
      height: 'auto',
      width: '900px',
      data: { isWinOrList: true, title: 'O cliente ganhou a licitação', placeHolder: 'Informe o valor final (R$)', isCurrency: true }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) { this.confirmWin(result, bidding.uid); }
    });
  }

  confirmWin(result: any, uid: string) {
    const updatingObj = {
      status: BiddingStatus.EARNED,
      earningPrice: result.inputData,
      updatingDate: Date.now(),
      updatingAction: BiddingUpdateAction.EARNED
    };

    if (result.participants) {
      updatingObj['participants'] = result.participants;
    }
    if (result.position) {
      updatingObj['position'] = result.position;
    }
    if (result.observation) {
      updatingObj['observations'] = result.observation;
    }

    this.dbService.update(`biddings/${uid}`, updatingObj)
      .then(() => {
        Materialize.toast('Licitação atualizada com sucesso', 2000);
        this.resetData();
      });
  }

  openLostModal(bidding: Bidding) {
    const dialogRef = this.dialog.open(RejectBiddingComponent, {
      height: 'auto',
      width: '900px',
      data: { }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) { this.confirmLost(result, bidding.uid); }
    });
  }

  openFailModal(bidding: Bidding) {
    const dialogRef = this.dialog.open(RejectBiddingComponent, {
      height: 'auto',
      width: '900px',
      data: { }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) { this.confirmFail(result, bidding.uid); }
    });
  }

  confirmLost(result: any, uid: string) {
    const updatingObj = {
      status: BiddingStatus.LOST,
      lostPrice: result.value,
      lostCompetitor: result.company,
      updatingDate: Date.now(),
      updatingAction: BiddingUpdateAction.FAIL
    };

    if (result.participants) {
      updatingObj['participants'] = result.participants;
    }
    if (result.position) {
      updatingObj['position'] = result.position;
    }
    if (result.observation) {
      updatingObj['observations'] = result.observation;
    }

    this.dbService.update(`biddings/${uid}`, updatingObj)
      .then(() => {
        Materialize.toast('Licitação atualizada com sucesso', 2000);
        this.resetData();
      });
  }

  confirmFail(result: any, uid: string) {
    const updatingObj = {
      status: BiddingStatus.FAIL,
      lostPrice: result.value,
      lostCompetitor: result.company,
      updatingDate: Date.now(),
      updatingAction: BiddingUpdateAction.LOST
    };

    if (result.participants) {
      updatingObj['participants'] = result.participants;
    }
    if (result.position) {
      updatingObj['position'] = result.position;
    }
    if (result.observation) {
      updatingObj['observations'] = result.observation;
    }

    this.dbService.update(`biddings/${uid}`, updatingObj)
      .then(() => {
        Materialize.toast('Licitação atualizada com sucesso', 2000);
        this.resetData();
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/biddings/biddings.component.ts